type FileNameProps = {
  filename: string;
};

export const FileName = ({ filename }: FileNameProps) => <>{removeFiletypeFromFilename(filename)}</>;

export const removeFiletypeFromFilename = (filename: string) => filename.replace(/\.[^/.]+$/, '');
